<template>
  <div class="flex items-center pt-2 pb-1 pr-2">
    <svg class="w-5 mr-2 fill-current" viewBox="0 0 82 46" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.299988 0.900024V45.1H71.1V34.5H81.7V11.5H71.1V0.900024H0.299988ZM65.1 39.1H6.29999V6.90003H65.1V39.1ZM75.7 17.5V28.5H71.1V17.5H75.7Z" />
      <path class="b1" d="M21.1 14H15.1V32.08H21.1V14Z" />
      <path class="b2" d="M38.2 14H32.2V32.08H38.2V14Z" />
      <path class="b3" d="M55.2 14H49.2V32.08H55.2V14Z" />
    </svg>
    <span class="text-xs">
      {{ Batt1 }}%
    </span>
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    Batt1() {
      return this.config?.rcPlus?.status?.capacity_percent != undefined
        ? this.config.rcPlus.status.capacity_percent
        : ENV.NO_DATA;
    },
  },
};
</script>
